import {
    AdfoxInfoForm,
    AdfoxPlacement,
    AdfoxTapTarget,
    DEFAULT_ADFOX_INFO_FORM,
    isBrowserTapAllowed,
} from 'components/Admin/AdfoxInfo/adfoxInfoModel';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

// ----------------------- actions -------------------------------------
const UPDATE_ADFOX_INFO_FORM = 'UPDATE_ADFOX_INFO_FORM';
const SET_ADFOX_INFO_PLACEMENT = 'SET_ADFOX_INFO_PLACEMENT';
const RESET_ADFOX_INFO_FORM = 'RESET_ADFOX_INFO_FORM';

interface PayloadTypes {
    [UPDATE_ADFOX_INFO_FORM]: Partial<Omit<AdfoxInfoForm, 'placement'>>;
    [SET_ADFOX_INFO_PLACEMENT]: AdfoxPlacement;
    [RESET_ADFOX_INFO_FORM]: null;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const updateAdfoxInfoForm = ActionCreator(UPDATE_ADFOX_INFO_FORM);
export const setAdfoxInfoPlacement = ActionCreator(SET_ADFOX_INFO_PLACEMENT);
export const resetAdfoxInfoForm = ActionCreator(RESET_ADFOX_INFO_FORM);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
export default createReducer<AdfoxInfoForm, PayloadTypes>(DEFAULT_ADFOX_INFO_FORM, {
    [UPDATE_ADFOX_INFO_FORM]: (state, { payload }) => ({ ...state, ...payload }),
    [SET_ADFOX_INFO_PLACEMENT]: (state, { payload }) => ({
        ...state,
        placement: payload,
        tapTarget: isBrowserTapAllowed(payload) ? state.tapTarget : AdfoxTapTarget.InApp,
    }),
    [RESET_ADFOX_INFO_FORM]: () => DEFAULT_ADFOX_INFO_FORM,
});
// ----------------------- /reducer --------------------------------------
